// src/components/common/DataFieldWithHelp.jsx
import React, { useState } from "react";
import { Flex, Text, Button } from "@aws-amplify/ui-react";
import DesktopHelpIcon from "./DesktopHelpIcon";

export default function DataFieldWithHelp({ label, value, helpText }) {
  const [showHelpMobile, setShowHelpMobile] = useState(false);

  return (
    <Flex direction="column" alignItems="flex-start" gap="0.1rem">
      {/* Row with label + icon + value + mobile "Learn more" */}
      <Flex alignItems="center" gap="0.5rem" flexWrap="wrap">
        {/* Label + desktop tooltip icon */}
        <Flex as="span" alignItems="center" gap="0.15rem">
          <Text as="span" fontSize="0.85rem" fontWeight={600}>
            {label}:
          </Text>
          {helpText && (
            <DesktopHelpIcon title={helpText} />
          )}
        </Flex>

        {/* Value + mobile learn more button in the SAME little row */}
        <Flex as="span" alignItems="center" gap="0.25rem">
          <Text fontSize="0.85rem">
            {value}
          </Text>

          {helpText && (
            <Button
              variation="link"
              size="small"
              onClick={() => setShowHelpMobile((prev) => !prev)}
              paddingInlineStart={0}
              paddingInlineEnd={0}
              display={{ base: "inline-flex", large: "none" }}
              marginLeft="0.35rem"
            >
              {showHelpMobile ? "Hide help" : "Learn more"}
            </Button>
          )}
        </Flex>
      </Flex>

      {/* Mobile-only help text under the entire row */}
      {helpText && showHelpMobile && (
        <Text
          variation="tertiary"
          fontSize="0.75rem"
          display={{ base: "block", large: "none" }}
          marginTop="0.1rem"
        >
          {helpText}
        </Text>
      )}
    </Flex>
  );
}
